export const setPageTitle = (title) => {
  document.title = title || 'BookMyShow';
}